import React from "react";
import PropTypes from "prop-types";

const renderElementFromObject = (elementObj) => {
    if (typeof elementObj === 'string' || typeof elementObj === 'number') return elementObj;
    if (!elementObj || typeof elementObj !== 'object') return null;

    const { type, props } = elementObj;

    const children = Array.isArray(props?.children)
        ? props.children.map((child, i) => renderElementFromObject(child))
        : renderElementFromObject(props?.children);

    return React.createElement(type, { ...props, key: props?.key || Math.random() }, children);
};

const Button = ({
    text,
    onClick,
    icon = false,
    prefixIcon = false,
    loading = false,
    btnType = "default",
    customClassName = "",
    disabled = false,
    type = "button",
    textClassName = "",
    ...props
}) => {
    const defaultClasses = "br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac";
    const btnTypeClasses = btnType === "warningOutlined" ? "bg1 c4 bw1px bss bo4 br50px" : btnType === "warning" ? "bg4 c1" : btnType === "dark" ? "bg2 c1" : "bg3 c1";
    const disabledClass = (disabled ?? loading) ? "button-disabled op60" : "";

    const combinedClasses = `${defaultClasses} ${btnTypeClasses} ${disabledClass} ${customClassName}`;
    return (
        <button
            onClick={(e) => {
                if (!loading && !disabled) {
                    onClick?.(e);
                }
            }}
            className={combinedClasses}
            type={type}
            {...props}
        >
            {prefixIcon && <span className="mr0-5rem df aic">{prefixIcon}</span>}
            <span className={textClassName}>
                {typeof text === 'object' ? renderElementFromObject(text) : text}
            </span>
            {icon && <span className="ml0-5rem df aic">{icon}</span>}
        </button>
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.element,
    loading: PropTypes.bool,
    btnType: PropTypes.oneOf(["default", "warning"]),
    customClassName: PropTypes.string
};

export default Button;
